import Page from "../Page";
import { Box } from "@mui/material";
import AdvancedMapView from "./AdvancedMapView";
import { useList } from "src/hooks/useFetch.hook";
import { Loader } from "../Loader";
import { Helmet } from "react-helmet-async";

const MapComponent = () => {
    const { data: chargers, isFetching } = useList("chargers", true, { c: false });
    
    // Detect if this is being used in dashboard vs dedicated map page
    const isMapPage = window.location.pathname.includes('/map');

    if(isFetching) {
        return <Loader />
    }
    
    // Full-screen map layout for dedicated map page
    if (isMapPage) {
        return (
            <>
                <Helmet>
                    <title>Charging Stations Map - Full Screen</title>
                </Helmet>
                <Box 
                    sx={{ 
                        height: '100vh',
                        width: '100%',
                        overflow: 'hidden',
                        margin: 0,
                        padding: 0,
                        position: 'relative'
                    }}
                >
                    <AdvancedMapView 
                        chargers={chargers?.chargers || chargers || []} 
                        searchBarEnabled={true}
                        isMapPage={isMapPage}
                        height="100vh"
                    />
                </Box>
            </>
        );
    }
    
    // Regular layout for dashboard/embedded use (fallback)
    return (
        <Page title="Map">
            <Box 
                sx={{ 
                    height: 'calc(100vh - 120px)', 
                    minHeight: '70vh',
                    width: '100%',
                    overflow: 'hidden',
                    position: 'relative'
                }}
            >
                <AdvancedMapView 
                    chargers={chargers?.chargers || chargers || []} 
                    searchBarEnabled={true}
                    isMapPage={isMapPage}
                    height="100%"
                />
            </Box>
        </Page>
    );
}

export default MapComponent;